import React from 'react';
import { ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  text?: string;
  href?: string;
  external?: boolean;
}
export function CTAButton({
  className = '',
  text = 'SÍ, QUIERO LIMPIAR MI CRÉDITO AHORA',
  href = '#comprar',
  external = false
}: CTAButtonProps) {
  const externalProps = external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return <div className={`flex flex-col items-center ${className}`} data-id="element-14">
      <a href={href} {...externalProps} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-lg md:text-xl font-display uppercase tracking-wide text-brand-dark bg-brand-green rounded-lg overflow-hidden transition-all hover:scale-105 hover:bg-white animate-pulse-glow w-full sm:w-auto text-center" data-id="element-15">
        <span className="relative z-10" data-id="element-16">{text}</span>
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-17"></div>
      </a>
      <div className="mt-3 flex items-center gap-2 text-sm text-gray-400" data-id="element-18">
        <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-19" />
        <span data-id="element-20">Acceso inmediato tras la compra. Pago seguro y privado.</span>
      </div>
    </div>;
}